






































































import { Component, Vue } from 'vue-property-decorator';
import { Mapping } from '@/store/types';
import { namespace } from 'vuex-class';
import { AssetActions } from '@/store/asset/actions';
import {
  iBaseCampFileMapper,
  iBasecampColumn,
  iBaseCampFileMapperOptions,
  IBaseCampFileMapperWithOptions,
} from '../ScopeAddition/iBaseCampFileMapper';
import iFileMapper, {
  iFileMapperOptions,
  iFileMapperWithOptions,
} from '../ScopeAddition/iFileMapper';
import { AssetType } from '../Maps/types';

const assetModule = namespace('asset');
const projectModule = namespace('project');

const ALERT_TYPE_ERROR = 'error';
const ALERT_TYPE_SUCCESS = 'success';
const ALERT_TYPE_INFO = 'info';

@Component({
  components: {},
})
export default class ImportInspectionUpdates extends Vue {
  nasscoTypeOptions = [AssetType.MANHOLE, AssetType.LINE_SEGMENT];

  selectedNassco = this.nasscoTypeOptions[0];

  email = `${this.$auth.user.email}`;

  emailRules = [
    (v: string): string | boolean => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
      || v === ''
      || 'Email must be valid',
  ];

  selectedFile = null;

  uploadFileColumns = [];

  uploadFileName = '';

  showAlert = false as boolean;

  alertType = ALERT_TYPE_ERROR as string;

  alertText = '' as string;

  rzFileColumns: Mapping[] = [];

  validForm = false;

  NASSCO_MANHOLE_IMPORT_FILE_MAPPING_GUID =
    '43118bc2-495d-11f1-b778-572e38beed58';

  NASSCO_LINE_SEGMENT_FILE_MAPPING_GUID =
    '411a8864-497b-11f1-b77a-338dc316a6e7';

  @assetModule.State('loading') assetModuleLoading: boolean | undefined = undefined;

  @assetModule.Action(AssetActions.POST_FILE_DATA) postFileData;

  @assetModule.Action(AssetActions.POST_FILE_MAPPING_DATA) postMappingData;

  @projectModule.State('projectGuids') projectGuids: string[];

  generateFileImportMappings(): string[] {
    switch (this.selectedNassco) {
      case AssetType.MANHOLE:
        return [this.NASSCO_MANHOLE_IMPORT_FILE_MAPPING_GUID];
      case AssetType.LINE_SEGMENT:
        return [this.NASSCO_LINE_SEGMENT_FILE_MAPPING_GUID];
      default:
        return [];
    }
  }

  isValidForm(): boolean {
    if ((this.$refs.nasscoForm as any).validate()) {
      return true;
    }
    this.alertType = ALERT_TYPE_ERROR;
    this.alertText = 'Please enter required fields';
    this.showAlert = true;
    return false;
  }

  async onClickUpload(): Promise<void> {
    if (!this.isValidForm()) return;
    // temporary values for assetChosen, gasGISData, hasInspections
    const payload = {
      selectedFile: this.selectedFile,
      mappings: this.generateFileImportMappings(),
    };
    try {
      const status = await this.postFileData(payload);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.uploadFileColumns = status.FileHeaders;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.rzFileColumns = status.RzColumns;
      this.uploadFileName = status.FileName;

      const selectedFileColumn = this.rzFileColumns.map((x) => x.databaseName);

      const fileMapper: iFileMapper[] = [];
      for (let i = 0; i < this.rzFileColumns.length; i += 1) {
        const fm: iFileMapper = {} as iFileMapper;
        fm.RzColumn = this.rzFileColumns[i];
        fm.FileColumn = selectedFileColumn[i];
        fileMapper.push(fm);
      }

      const fileMapperOptions: iFileMapperOptions = {
        Email: this.email,
      };

      const fileMapperWithOptions: iFileMapperWithOptions = {
        Options: fileMapperOptions,
        Mappings: fileMapper,
      };
      this.columnsMappedComplete(fileMapperWithOptions);
    } catch (e) {
      this.alertType = ALERT_TYPE_ERROR;
      this.alertText = (e as Error).message;
      this.showAlert = true;
    }
  }

  onClickCancel(): void {
    (this.$refs.nasscoForm as any).reset();
    this.selectedFile = null;
    this.showAlert = false;
  }

  async columnsMappedComplete(
    fileMapperWithOptions: iFileMapperWithOptions,
  ): Promise<void> {
    if (!this.projectGuids) {
      this.alertType = ALERT_TYPE_ERROR;
      this.alertText = 'No valid project';
      this.showAlert = true;
      return;
    }
    const fileMapper = fileMapperWithOptions.Mappings;
    const basecampFileMapper = {} as iBaseCampFileMapper;
    basecampFileMapper.FileName = this.uploadFileName;
    // eslint-disable-next-line prefer-destructuring
    basecampFileMapper.ProjectGuid = this.projectGuids[0];
    basecampFileMapper.FileImportMappingGuids = this.generateFileImportMappings();
    basecampFileMapper.Columns = [];
    for (let i = 0; i < fileMapper.length; i += 1) {
      const bc = {} as iBasecampColumn;
      bc.RedzoneColumn = fileMapper[i].RzColumn;
      bc.FileColumn = fileMapper[i].FileColumn;
      basecampFileMapper.Columns.push(bc);
    }

    const fileMapperOptions: iBaseCampFileMapperOptions = {
      email: fileMapperWithOptions.Options.Email,
    };

    const fileMapperDTO: IBaseCampFileMapperWithOptions = {
      options: fileMapperOptions,
      mapping: basecampFileMapper,
    };

    try {
      await this.postMappingData(JSON.stringify(fileMapperDTO));
    } catch (e) {
      this.alertType = ALERT_TYPE_ERROR;
      this.alertText = 'There was an error sending your scope request';
      this.showAlert = true;
      return;
    }
    this.showAlert = true;
    this.alertText = 'Submission Succesful! An email will be sent when the request is completed.';
    this.alertType = ALERT_TYPE_SUCCESS;
    this.selectedFile = null;
    (this.$refs.nasscoForm as HTMLFormElement).resetValidation();
  }
}
